define('models/pages/wishlist/index',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var WishlistPageViewModel = Model.extend({
        urlPath: '/page/wishlist',
    });

    return WishlistPageViewModel;
});
